import { createInputs, createModel, loadOnnx } from './onnxInferenceServiceBasicMethods';
export class OnnxInferenceService {
    constructor() {
    }
    static createFactory(appName, version, wasmPath) {
        return () => {
            var _a;
            if (!OnnxInferenceService.onnxRetrievalPromise) {
                if (!appName || !version) {
                    return Promise.reject(new Error(`Error: appName and/or version not provided`));
                }
                return (((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.top) === null || _a === void 0 ? void 0 : _a.ort) ? Promise.resolve() : loadOnnx(this.createCdnUrl(appName, version), 'ort', wasmPath))
                    .then(() => {
                    OnnxInferenceService.onnxRetrievalPromise = Promise.resolve(new OnnxInferenceService());
                }).catch((err) => {
                    OnnxInferenceService.onnxRetrievalPromise = Promise.reject(err);
                }).then(() => {
                    return OnnxInferenceService.onnxRetrievalPromise;
                });
            }
            else {
                return OnnxInferenceService.onnxRetrievalPromise;
            }
        };
    }
    static createCdnUrl(appName, version) {
        // TODO add correct logic
        const cdnUrl = `https://${appName}${version}`;
        return cdnUrl;
    }
    createModel(modelUrl, modelName) {
        var _a;
        const ort = (_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.top) === null || _a === void 0 ? void 0 : _a.ort;
        return createModel(modelUrl, modelName ? modelName : '', ort);
    }
    createInputs() {
        return createInputs();
    }
}
//# sourceMappingURL=onnxInferenceService.js.map